import React, { useState, useRef } from 'react';
import eMedHub from "../Assets/Logo/eMedHub.jpeg";
import { Box, Button, IconButton, TextField, Typography, CircularProgress } from "@mui/material";
import InputAdornment from "@material-ui/core/InputAdornment";
import Logo from "../Assets/Logo/Logo.svg";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ToastMsg from "../Components/ToastMsg/ToastMsg";
import { ImagePaths } from "../Utility/ImagePaths";
import RestAPIService from "../Utility/Services/RestAPIService";
import { Serviceurls } from "../Utility/API/Serviceurls";
import Loader from '../Components/Loader';
import { withTranslation } from 'react-i18next';
import CommonValidation from "../Components/CommonFunctions/CommonValidation";
import { localClearItem, localSetItem, localClearAll } from "../Utility/Services/CacheProviderService";

const otpKeys = ['otp_num1', 'otp_num2', 'otp_num3', 'otp_num4', 'otp_num5', 'otp_num6'];

const UnlockAccount = (props) => {
    const [state, setState] = useState({
        // verify screen state
        username: "",
        password: "",
        showPassword: false,

        // otp screen state
        showMobileNo: "",
        mobileNo: "",
        isGenerateOtp: false,
        isOtpSuccess: false,
        seconds: 60,
        timerRunning: false,
        isResetOtp: false,

        // verify otp state
        otp_num1: '',
        otp_num2: '',
        otp_num3: '',
        otp_num4: '',
        otp_num5: '',
        otp_num6: '',
        isUnlock: false,

        // common state
        renderScreen: "verifyScreen",

        // message state
        isErrorMsg: false,
        isErrorMsgText: '',
        successMsg: false,
        successMsgText: '',
        isLoader: false,
    })

    const inputRefs = useRef({});
    const timerInterval = useRef(null);

    const updateState = (newData) => {
        setState((prevState) => ({
            ...prevState,
            ...newData
        }))
    }

    const errorMsg = (message) => {
        updateState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    const successMsg = (message) => {
        updateState({
            successMsg: true,
            successMsgText: message
        })
    }

    const msgClose = () => {
        updateState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        const number = CommonValidation.numberOnly(value)
        if (name.includes("otp_num")) {
            if (number || value === "") {
                updateState({ [name]: value });
                // Move to next input only if value is entered
                if (value) {
                    // Extract number from "otp_num" -> 1
                    const currentNum = parseInt(name.replace("otp_num", ""), 10);
                    const nextKey = `otp_num${currentNum + 1}`;

                    // Focus next field (if exists)
                    if (currentNum <= otpKeys?.length - 1) {
                        focusNext(nextKey);
                    }
                }
            }
        } 
        else if (name === "mobileNo") {
            if (number || value === "") {
                updateState({ [name]: value });
            }
        }
        else {
            updateState({ [name]: value });
        }
    }

    const startTimer = () => {
        updateState({ seconds: 60, timerRunning: true });
        if (timerInterval.current) {
            clearInterval(timerInterval.current);
        }
        timerInterval.current = setInterval(() => {
            setState((prevState) => {
                if (prevState.seconds > 0) {
                    return { ...prevState, seconds: prevState.seconds - 1 };
                } else {
                    clearInterval(timerInterval.current);
                    return { ...prevState, timerRunning: false };
                }
            })
        }, 1000);
    };

    // api calls start

    const submitVerify = () => {
        try {
            updateState({ isLoader: true })
            const data = {
                user_name: state.username,
                password: state.password
            }
            localClearItem("AccessToken");
            RestAPIService.create(data, Serviceurls.ACCOUNT_UNLOCK_VERIFY_POST)
                .then((response) => {
                    if (response.data.status === 'success') {
                        localSetItem("AccessToken", response.data.data.token);
                        updateState({
                            username: "",
                            password: "",
                            showPassword: false,
                            renderScreen: "otpScreen",
                            showMobileNo: response.data.data.mobile_number,
                            isLoader: false,
                        })
                    }
                }).catch((error) => {
                    updateState({ isLoader: false })
                    errorMsg(error?.response?.data?.message || error.message)
                })
        } catch (error) {
            updateState({ isLoader: false })
            errorMsg(error.message)
        }
    }

    const postGenerateOtp = (isFromResend = false) => {
        try {
            const key = isFromResend ? "isResetOtp" : "isGenerateOtp";
            updateState({
                [key]: true, 
                ...(isFromResend && {
                    otp_num1: '',
                    otp_num2: '',
                    otp_num3: '',
                    otp_num4: '',
                    otp_num5: '',
                    otp_num6: '',
                })
            });
            if (state.mobileNo?.length === 10) {
                const data = {
                    mobile_number: state.mobileNo,
                    resend_otp: isFromResend,
                }
                RestAPIService.create(data, Serviceurls.ACCOUNT_UNLOCK_GENERATE_OTP_POST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            successMsg(response.data.message)
                            startTimer()
                            updateState({
                                isOtpSuccess: true,
                                [key]: false,
                            })
                        }
                    }).catch((error) => {
                        updateState({ isOtpSuccess: false, [key]: false })
                        errorMsg(error?.response?.data?.message || error.message)
                    })
            } else {
                updateState({ isOtpSuccess: false, [key]: false })
                errorMsg('Please Enter Valid Mobile No')
            }
        } catch (error) {
            updateState({ isOtpSuccess: false, [isFromResend ? "isResetOtp" : "isGenerateOtp"]: false })
            errorMsg(error.message)
        }
    }

    const postUnlockAccount = () => {
        try {
            const otp_code = `${state.otp_num1}${state.otp_num2}${state.otp_num3}${state.otp_num4}${state.otp_num5}${state.otp_num6}`;
            if (otp_code?.length === 6) {
                updateState({ isUnlock: true })
                const data = { otp: otp_code }
                RestAPIService.create(data, Serviceurls.ACCOUNT_UNLOCK_POST)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            localClearAll();
                            successMsg(response.data.message);
                            props.history.push('/');
                            updateState({
                                isUnlock: false,
                                isOtpSuccess: false,
                                otp_num1: '',
                                otp_num2: '',
                                otp_num3: '',
                                otp_num4: '',
                                otp_num5: '',
                                otp_num6: '',
                                renderScreen: "verifyScreen",
                            })
                        }
                    }).catch((error) => {
                        updateState({
                            isUnlock: false,
                        })
                        errorMsg(error?.response?.data?.message || error.message)
                    })
            } else {
                updateState({
                    isUnlock: false,
                })
                errorMsg('Please Enter the valid OTP')
            }
        } catch (error) {
            updateState({ isUnlock: false })
            errorMsg(error.message)
        }
    }
    // api calls end

    const renderVerify = () => {
        return (<form autoComplete="off"
            onSubmit={(e) => {
                e.preventDefault();
                submitVerify();
            }}
        >
            <Box className="eMed_Forget_Box">
                <Box className='eMed_Forget_HeadCon'>
                    <IconButton onClick={() => { props.history.push('/') }}>
                        <img className="eMed_DisSum_Lay_StarIcon" src={ImagePaths.Back_Arrow.default} alt="Back" />
                    </IconButton>
                    <Typography id='eMed_Forget_HeaderText'>{'Unlock Your Account'}</Typography>
                </Box>

                <TextField
                    id="userName"
                    size="small"
                    name="username"
                    variant="outlined"
                    inputProps={{ emed_tid: 'username', autoComplete: 'off' }}
                    value={state.username}
                    sx={{ margin: '2vw 1vw 1vw 1vw' }}
                    onChange={onChange}
                    label={t("userName")}
                />

                <TextField
                    size="small"
                    value={state.password}
                    id="newPassword"
                    variant="outlined"
                    sx={{ margin: '1vw' }}
                    inputProps={{ emed_tid: 'password', autoComplete: 'new-password' }}
                    name="password"
                    onChange={onChange}
                    label={t("Password")}
                    type={state.showPassword ? "text" : "password"}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment>
                                <IconButton onClick={() => updateState({ showPassword: !state.showPassword })} >
                                    {state.showPassword ? (<VisibilityIcon />) : (<VisibilityOffIcon />)}
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />

                <Box display="flex" justifyContent="center">
                    <Button
                        id="eMed_Forget_Btn"
                        variant="contained"
                        size="small"
                        emed_tid=""
                        type="submit" // triggers form submission on Enter
                        disabled={(!state.username || !state.password) || state.isLoader}
                    >
                        Verify
                    </Button>
                </Box>
            </Box>
        </form>)
    }

    const focusNext = (nextKey) => {
        const nextRef = inputRefs.current[nextKey];
        nextRef.focus();  // Move to next input
    };

    const renderOtpField = (stateKey) => {
        return (
            <TextField
                size="small"
                key={stateKey}
                value={state[stateKey]}
                sx={{ width: '3vw' }}
                name={stateKey}
                inputProps={{ maxLength: 1 }}
                variant="outlined"
                inputRef={(el) => (inputRefs.current[stateKey] = el)}
                onChange={onChange}
            />
        )
    }

    const renderOtp = () => {
        const otp_code = `${state.otp_num1}${state.otp_num2}${state.otp_num3}${state.otp_num4}${state.otp_num5}${state.otp_num6}`;
        return (
            <Box className="eMed_Forget_Box">
                <Box className='eMed_Forget_HeadCon'>
                    <IconButton onClick={() => { localClearItem("AccessToken"); props.history.push('/'); }}>
                        <img className="eMed_DisSum_Lay_StarIcon" src={ImagePaths.Back_Arrow.default} alt="Back" />
                    </IconButton>
                    <Typography id='eMed_Forget_HeaderText'>{'Unlock Your Account'}</Typography>
                </Box>

                <Typography id='eMed_Forget_HelpText'>{`Please Enter Mobile Number ${state.showMobileNo || ""}`}</Typography>
                <TextField
                    size="small"
                    inputProps={{ maxLength: 10 }}
                    sx={{ margin: '0.5vw' }}
                    id="Forget-password"
                    value={state.mobileNo}
                    disabled={state.isOtpSuccess}
                    label="Mobile No"
                    name="mobileNo"
                    onChange={onChange} />

                <Box display={state.isOtpSuccess ? "none" : "flex"} justifyContent="center">
                    <Button id="eMed_Forget_Btn" variant="contained" size="small" disabled={state.mobileNo === "" || state.mobileNo?.length !== 10 || state.isGenerateOtp} onClick={() => postGenerateOtp(false)}>
                        {state.isGenerateOtp ? <CircularProgress sx={{ color: 'white' }} size={20} /> : "Generate OTP"}
                    </Button>
                </Box>

                {state.isOtpSuccess ? <Box>
                    <Typography id='eMed_Forget_HelpText'>Verify OTP</Typography>
                    <Box margin={'0.5vw'} display={'flex'} flexDirection={'row'} justifyContent={'space-between'}>
                        {otpKeys?.map(key => renderOtpField(key))}
                    </Box>
                    <Box display="flex" justifyContent="end" marginy={'0.625vw'}>
                        <Button sx={{textTransform: "capitalize"}} variant="text" size="small" disabled={state.timerRunning || state.isResetOtp} onClick={() => postGenerateOtp(true)}>
                            {state.isResetOtp ? <CircularProgress sx={{ color: 'white' }} size={20} /> : `Haven't Received OTP? Resend OTP in (${state.seconds}s)`}
                        </Button>
                    </Box>
                    <Box display="flex" justifyContent="center">
                        <Button id="eMed_Forget_Btn" variant="contained" size="small" disabled={otp_code?.length !== 6 || state.isUnlock} onClick={postUnlockAccount}>
                            {state.isUnlock ? <CircularProgress sx={{ color: 'white' }} size={20} /> : "Unlock Account"}
                        </Button>
                    </Box>
                </Box> : null}

            </Box>
        )
    }

    const { t } = props;

    return (
        <div className="total">
            <Loader loaderOpen={state.isLoader} />
            <div className="left"> <img src={eMedHub} width="100%" height="100%" alt="login-img" /> </div>

            <Box className="eMed_Forget_Con">
                <img src={Logo} alt="logo" style={{ width: '6vw', height: '6vw' }} />
                {{
                    verifyScreen: renderVerify(),
                    otpScreen: renderOtp(),
                }[state.renderScreen] || null}
            </Box>

            {state.isErrorMsg ? (<ToastMsg severity={'error'} msg={state.isErrorMsgText} msgPop={msgClose.bind(this)} />)
                : state.successMsg ? (<ToastMsg severity={'success'} msg={state.successMsgText} msgPop={msgClose.bind(this)} />)
                    : null}
        </div>
    )
}

export default withTranslation()(UnlockAccount);